var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadingStatus)?_c('div',{staticClass:"spinner-placeholder"},[_vm._v(" Loading "),_c('div',{staticClass:"loader quantum-spinner"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }